<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>

    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Nature Of Expense Masters Details</b-navbar-brand>
        </b-navbar>

        <b-card>
          <div class="row align-items-end">
            <div class="col-md-3">
              <b-button size="sm" class="pull-left" @click="AddNOEModal('add', '')" variant="primary">Add</b-button>
            </div>
            <div class="col-md-3"></div>
            <div class="col-md-3"></div>
            <div class="col-md-3"></div>
            <div class="col-md-3">
              <label for="blType">Date</label>
              <date-range-picker :opens="openRight" :always-show-calendars="showCal" v-model="dateRange"
                :startDate="startDate" :endDate="endDate" :locale-data="locale">
              </date-range-picker>
            </div>
            <div class="col-md-3">
              <label for="nature_nameFilter">Name</label>
              <b-form-input :formatter="capitalizeAll" v-model="Filter.nature_nameFilter" type="text"
                placeholder="Enter Nature Of Expense Name"></b-form-input>
            </div>
            <div class="col-md-3">
              <label for="nature_codeFilter">Code</label>
              <b-form-input :formatter="capitalizeAll" v-model="Filter.nature_codeFilter" type="text"
                placeholder="Enter Nature Of Expense Name"></b-form-input>
            </div>
            <div class="col-md-3">
              <label for="statusFilter">Status</label>
              <model-list-select :list="statusList" id="statusFilter" v-model="Filter.statusFilter" option-value="inv"
                option-text="int" placeholder="Select Status">
              </model-list-select>
            </div>

            <div class="col-md-12 mt-2 text-right">
              <b-button size="sm" @click="filterSearch" variant="outline-primary">Search</b-button>
              <b-button size="sm" class="ml-3" @click="clearFilter" variant="outline-info">clear</b-button>
              <b-button :disabled="ExcelBtnName != 'Export as Excel' ? true : false" class="ml-3"
                @click="getReports('Currency_REPORTS_SCREEN', 'Export as Excel')" size="sm" variant="outline-info">{{
                  ExcelBtnName }}
                <b-spinner v-if="ExcelBtnName != 'Export as Excel'" small label="Small Spinner"></b-spinner></b-button>
            </div>
          </div>

          <b-row>
            <b-col cols="12" class="ml-2 text-right"> </b-col>
          </b-row>
        </b-card>

        <div class="box">
          <div>
            <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
              :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
          </div>
          <div>
            <b-row class="align-content-end mt-3">
              <b-col cols="8"> </b-col>
              <b-col cols="2">
                <h5 class="text-muted pull-right">
                  <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                </h5>
              </b-col>
            </b-row>
          </div>
          <div class="table-responsive tableMain mt-2">
            <b-table show-empty stacked="md" :items="getNatureOfExpenseList" :fields="fields" :per-page="perPage"
              :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
              <template slot="SN" slot-scope="row0">
                <span>{{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                    }}</span>
              </template>
              <template slot="nature_name" slot-scope="row1">
                <b v-if="row1.item.nature_description">Desc : {{ row1.item.nature_description }}<br /></b>
                <b v-if="row1.item.nature_name">Name : {{ row1.item.nature_name }}<br /></b>
                <b v-if="row1.item.nature_code">Code : {{ row1.item.nature_code }}<br /></b>
                <span>Created Dt. :{{ row1.item.nature_created_at | moment }}<br /></span>
                <span> By : {{ row1.item.nature_cu_relation.employeeName }}</span> <br />
              </template>
              <template slot="nature_is_active" slot-scope="row5">
                <b>{{ row5.item.nature_is_active?'Active':'Inactive'}}</b><br />
              </template>
              <template slot="nature_id" slot-scope="row4">
                <b-button
                  v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'"
                  style="font-size: 0.675rem" size="sm" class="mb-1" @click="AddNOEModal('edit', row4.item)"
                  variant="primary">Update<br /></b-button>
              </template>
            </b-table>
          </div>
        </div>

        <div>
          <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
            :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

    <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="modal-Add-Open" hide-footer
      :title="natureOfExpenseDetails.Type == 'add' ? 'Add Nature Of Expense' : 'Update Nature Of Expense'">
      <b-row class="justify-content-center">
        <b-col md="3" class="mt-2">
          <label for="nature_name">Name : <span class="error">*</span></label>
          <b-form-input :formatter="capitalizeAll" v-model="natureOfExpenseDetails.nature_name" type="text"
            placeholder="Enter Name"></b-form-input>
          <span class="error" v-if="!natureOfExpenseDetails.nature_name">{{ errornatureOfExpenseDetails.nature_name
          }}</span>
        </b-col>
        <b-col md="3" class="mt-2">
          <label for="nature_code">Code : </label>
          <b-form-input :formatter="capitalizeAll" v-model="natureOfExpenseDetails.nature_code" type="text"
            placeholder="Enter Code"></b-form-input>
          <span class="error" v-if="!natureOfExpenseDetails.nature_code">{{ errornatureOfExpenseDetails.nature_code
          }}</span>
        </b-col>
        <b-col md="3" class="mt-2">
          <label for="nature_description">Description : </label>
          <b-form-input :formatter="capitalizeAll" v-model="natureOfExpenseDetails.nature_description" type="text"
            placeholder="Enter Description"></b-form-input>
          <span class="error" v-if="!natureOfExpenseDetails.nature_description">{{
            errornatureOfExpenseDetails.nature_description }}</span>
        </b-col>


        <b-col md="12" class="text-center">
          <b-button :disabled="isNaturedisabled" class="mt-3 sm" variant="success"
            v-if="natureOfExpenseDetails.nature_name != ''" @click="submitNatueOfExpense">{{ buttonTxt }}</b-button>
          <b-button class="mt-3 sm" variant="outline-danger" @click="closeModalAdd">Close</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Added By Priyanshu SIngh End -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters.js";
import DateRangePicker from "vue2-daterange-picker";
import CustomLoader from "../common/customLoader.vue";
import {
  globalPermissionStatus,
  lastVisitPage,
  GlobalGetLocation,
} from "../../helper/collection.js";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    this.$store.dispatch("setCurrentRoute", "/currencyMaster");
    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.viewgetNatureOfExpenseList("0", "1", "1");
    }
  },

  data() {
    return {
      Filter: {
        nature_nameFilter: '',
        nature_codeFilter: '',
        statusFilter: '',
      },

      statusList: [
        {
          inv: "1",
          int: "Active",
        },
        {
          inv: "0",
          int: "In-Active",
        },
        {
          inv: "",
          int: "All",
        },
      ],
      ExcelBtnName: "Export as Excel",
      //Added By Priyanshu Singh Console Currency Variable Start
      buttonTxt: "Save",
      isNaturedisabled: false,
      selectDateFormat,
      natureOfExpenseDetails: {
        Type: "add",
        nature_id: 0,
        nature_name: "",
        nature_description: "",
        nature_code: "",
      },
      errornatureOfExpenseDetails: {
        nature_name: "",
        // nature_code: "",
      },
      arrayErrornatureOfExpenseDetails: [
        {
          nature_name: "Please Enter Name",
          // nature_code: "Please Enter Code",
        },
      ],
      getNatureOfExpenseList: [],
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      openRight: "right",
      showCal: false,
      showDash: false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      statusList: [
        {
          inv: "1",
          int: "Active",
        },
        {
          inv: "0",
          int: "In-Active",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      validate: false,
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      totalRows: 0,

      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "nature_name",
          mainkey: "nature_name",
          label: "Name",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "nature_code",
          mainkey: "nature_code",
          label: "Code",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "nature_is_active",
          mainkey: "nature_is_active",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "nature_id",
          mainkey: "nature_id",
          label: "Actions",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      reload: true,
      //Added By Priyanshu Singh  Console natureOfExpense Variable Start
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },
  destroyed() { },

  components: {
    // Loading,
    DatePicker,
    ModelListSelect,
    MultiSelect,
    DateRangePicker,
    CustomLoader,
  },

  computed: {},
  watch: {},
  methods: {
    wordWrap,
    previousSalesView() {
      window.history.go(-1);
    },
    validateNatureOfExpense() {
      let validate_new = true;
      Object.keys(this.errornatureOfExpenseDetails).map((x, index) => {
        if (this.natureOfExpenseDetails[x] == "") {
          this.errornatureOfExpenseDetails[x] = this.arrayErrornatureOfExpenseDetails[0][x];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    submitNatueOfExpense() {
      this.validateNatureOfExpense();
      if (this.validate == false) return false;
      this.isLoading = true;
      this.isNaturedisabled = true;
      if (this.validate != false) {
        try {
          NodeLockPannelService.upsertNatureOfExpense(this.natureOfExpenseDetails)
            .then((response) => {
              const { data, status, statusText } = response;
              console.log('BrfBookingList', data)
              if (status == 200 && data) {
                this.closeModalAdd();
                this.viewgetNatureOfExpenseList("Normal", "0", "0", "1", "1");
              }
              this.isLoading = false;
            })
            .catch((error) => {
              this.isSubmited = false;
              console.log("Catch on upsertNatureOfExpense Error: ", error);
            });

        } catch (error) {
          console.error("Error updating upsertNatureOfExpense:", error);
        }
      }
    },
    AddNOEModal(type, item) {
      this.natureOfExpenseDetails.Type = type;
      this.natureOfExpenseDetails.nature_name = "";
      this.natureOfExpenseDetails.nature_code = "";
      this.natureOfExpenseDetails.nature_description = "";
      if (type == "edit") {
        this.natureOfExpenseDetails.Type = type;
        this.natureOfExpenseDetails.nature_code = item.nature_code;
        this.natureOfExpenseDetails.nature_name = item.nature_name;
        this.natureOfExpenseDetails.nature_description = item.nature_description;
        this.natureOfExpenseDetails.nature_id = item.nature_id;
        this.buttonTxt = "Update";
      }
      this.$refs["modal-Add-Open"].show();
    },
    closeModalAdd() {
      this.natureOfExpenseDetails= {
        Type: "add",
        nature_id: 0,
        nature_name: "",
        nature_description: "",
        nature_code: "",
      };
      this.$refs["modal-Add-Open"].hide();
    },


    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewgetNatureOfExpenseList("Normal", "0", CURRENT, "2", event);
    },
    filterSearch() {
      this.reload = false;
      this.viewgetNatureOfExpenseList("Normal", "0", "0", "1", "1");
    },
    clearFilter() {    
      this.Filter= {
        nature_nameFilter: '',
        nature_codeFilter: '',
        statusFilter: '',
      };

      this.dateRange = {
        startDate: "",
        endDate: "",
      };
      this.viewgetNatureOfExpenseList("0", "1", "1");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set(
        "oldRoute",
        this.$router.history.current.fullPath
      );
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }
      this.viewgetNatureOfExpenseList(CURRENT, "2", event);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.viewgetNatureOfExpenseList("Excell", "0", "0", "1", "1");
    },
    viewgetNatureOfExpenseList(CURRENT, SEARCH, pageNumber) {
      this.getNatureOfExpenseList = [];
      this.isLoading = true;
      let payload = {
        excelId: 'Noraml_List_Page',
        cust_username: this.$sessionsStorage.get("cust_username"),
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        Currency: "Currency",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        generateExcel: this.generateExcel,
      };
      try {
        const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
        NodeLockPannelService.getNatureOfExpense(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log('BrfBookingList', data)
            if (status == 200 && data) {
              if (this.generateExcel == "1") {
                // Handle file download
                // const url = window.URL.createObjectURL(new Blob([data]));

                const blob = new Blob([data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Nature-Of-Expense.xlsx"); // Specify the file name
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.ExcelBtnName = "Export As Excel";
                this.generateExcel = "0";
                this.viewgetNatureOfExpenseList("Normal", "0", "0", "1", "1");
              } else {
                if (data.data.length > 0) {
                  this.totalRows = data.meta.totalNatureOfExpenses;
                  this.getNatureOfExpenseList = data.data;
                }
              }
            }
            this.isLoading = false;
          })
          .catch((error) => {
            this.isSubmited = false;
            console.log("Catch on getNatureOfExpense Error: ", error);
          });

      } catch (error) {
        console.error("Error updating getNatureOfExpense:", error);
      }
    },
    pagechangeData() {
      this.perPage = 25;
      this.reload = false;
      this.viewgetNatureOfExpenseList("Normal","0","0", "1", "1");
    },
    //Added By Priyanshu SIngh Multi Select End
  },
};
</script>



// WEBPACK FOOTER //
// natureOfExpenseMasters.vue?d376cca8